import { createFileRoute } from '@tanstack/react-router'
import { motion } from 'motion/react'
import { useIsMobile } from '@/lib/hooks'
import { ContentLink } from '@/components/ContentLink'

export const Route = createFileRoute('/legal')({
  component: LegalPage,
})

const LEGAL_LINKS = [
  { label: 'Privacy policy', path: '/privacy' },
  { label: 'Terms of use', path: '/terms' },
  { label: 'Subscription terms', path: '/subscription' },
  { label: 'Sub-processors', path: '/sub-processors' },
  { label: 'Data processing addendum', path: '/dpa' },
]

function LegalLink({ label, path, delay }: { label: string; path: string; delay: number }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay, ease: [0.33, 1, 0.68, 1] }}
      style={{ alignSelf: 'flex-start' }}
    >
      <ContentLink label={label} to={path} color="#ccfee7" fontSize="22px" fontWeight={300} />
    </motion.div>
  )
}

function LegalPage() {
  const isMobile = useIsMobile()

  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        padding: isMobile ? '0 48px' : '0 240px',
        boxSizing: 'border-box',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <h1 style={{ position: 'absolute', width: '1px', height: '1px', padding: 0, margin: '-1px', overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: 0 }}>Legal</h1>
        {LEGAL_LINKS.map((link, i) => (
          <LegalLink key={link.path} label={link.label} path={link.path} delay={i * 0.08} />
        ))}
      </div>
    </div>
  )
}
